import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError, refreshCsrfToken } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { PasswordInput } from "../../components/ui/password-input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function ChangePassword() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { setErr("passwords_do_not_match"); return; }
    if (next.length < 10) { setErr("password_min_10_chars"); return; }
    setBusy(true); setErr("");
    try {
      // First-login sessions are often clean, cross-origin mobile sessions.
      // Synchronize the backend cookie and in-memory header token immediately
      // before this security-sensitive mutation.
      await refreshCsrfToken();
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      await refresh();
      navigate("/");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-slate-50">
      <form onSubmit={submit} className="max-w-md w-full bg-white border border-slate-200 rounded-lg p-8 shadow-sm space-y-4">
        <h2 className="text-2xl font-semibold tracking-tight" style={{ fontFamily: "Manrope" }}>Change your password</h2>
        <p className="text-sm text-slate-500">Your account requires a password change on first login.</p>
        <div className="space-y-1">
          <Label>Current password</Label>
          <PasswordInput autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="current-password" />
        </div>
        <div className="space-y-1">
          <Label>New password</Label>
          <PasswordInput autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} required data-testid="new-password" />
        </div>
        <div className="space-y-1">
          <Label>Confirm new password</Label>
          <PasswordInput autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="confirm-password" />
        </div>
        {err && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded px-3 py-2" data-testid="cp-error">{err}</div>}
        <Button type="submit" disabled={busy} className="w-full rounded-full" data-testid="change-password-submit">
          {busy ? "Saving…" : "Update password"}
        </Button>
      </form>
    </div>
  );
}
